<template>

  <div class="createNewJourneyContent">
    <v-container class="mt-12 pt-12 mb-0 pb-0 px-0">
      <v-row class="mt-0 pt-0 mb-0 pb-0 px-4">
        <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0">
          <strong>{{$t('journeyTitle')}}</strong>
        </v-col>
        <v-col cols="12" class="mt-0 pt-0 mb-2 pb-4">
          <v-textarea solo @change="setJourneyTitle()" v-model="cacheJourney.journeyTitle" :rules="[v => (v || '' ).length >= 4 || $t('journeyTitleRule')]" :label=" $t('journeyTitleRule')" 
            auto-grow  background-color="grey lighten-4"  rows="1" row-height="15"></v-textarea>
        </v-col>
        <v-col cols="12" class="mt-0 pt-0 mb-2 pb-4">
          <strong>{{$t('journeyDescription')}}</strong>
          <v-textarea solo @change="setJourneyDescription()" :rules="[v => (v || '' ).length >= 4 || $t('journeyDescriptionRule')]" :label="$t('journeyDescriptionRule')" 
            v-model="cacheJourney.journeyDescription"  background-color="grey lighten-4" auto-grow outlined rows="1" row-height="15"></v-textarea>
        </v-col>
      </v-row>
      <v-row class="mt-0 pt-0 mb-0 pb-0 px-4">
        <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0">
          <selectJourneyBackgroundColor />
        </v-col>
      </v-row>
      <v-row class="mt-0 pt-0 mb-0 pb-0 px-4">
        <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0">
          <selectJourneyUnorderedOrOrdered />
        </v-col>
      </v-row>
      <journeyEditDragAndDrop :arrayStories="cacheJourney.storiesArrayObjectIdDescription"/>
      <v-footer class="text-center">
        <v-row class="mt-0 pt-0 mb-0 pb-0 px-0">
          <v-col cols="6" class="mt-0 pt-0 mb-0 pb-0">
            <v-btn :disabled="!disableSaveAsDraftJourney" class="btnPublishDraftJourney" @click="saveAsDraftNewJourney()">
              {{$t('saveAsDraftJourney')}}
            </v-btn>
          </v-col>
          <v-col cols="6" class="mt-0 pt-0 mb-0 pb-0">
            <v-btn :disabled="!disablePublishJourney" color="secondaryVariant" class="btnPublishDraftJourney" @click="publicNewJourney()">
              {{$t('publishJourney')}}
            </v-btn>
          </v-col>
        </v-row>
      </v-footer>
    </v-container>
    <v-dialog v-model="dialogSaveBeforeExit" hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogSaveBeforeExit = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-actions>
          <v-row align=center>
            <v-col cols=10>
              <span class="beforeLeaveCreate">{{$t('beforeLeaveCreate')}}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center" cols=12>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import journeyEditDragAndDrop from "@/components/journeyEditDragAndDrop.vue"
import selectJourneyBackgroundColor from "@/components/selectJourneyBackgroundColor.vue"
import selectJourneyUnorderedOrOrdered from "@/components/selectJourneyUnorderedOrOrdered.vue"

export default {
  name: "createNewJourneyContent",
  components: {

    journeyEditDragAndDrop,
    selectJourneyBackgroundColor,
    selectJourneyUnorderedOrOrdered

  },
  data: () => ({
    mapStoriesArrayObjectIdDescription:[],
    tempSingleStoryDetail: null,
    //only when the journey is in editing mode
    idJourney: null,
    singleJourneyDetail: null,
    isPublic: true,
    //cacheJourney:{journeyTitle:"",journeyDescription:"",journeyBackgroundColor:1,isPublic:false,isJourney:true},
    dialogSaveBeforeExit: false,
    readOnly: process.env.VUE_APP_READONLY,
    isKGenable: process.env.VUE_APP_ISKGENABLE,
    apiUrl: process.env.VUE_APP_ROOT_API,
    //all the information of the selected story
    singleStoryDetail: [],
  }),

  mounted() {
    if (this.$route.query.idJourney && this.$route.query.idStory) {
      this.getSingleJourney().then(() => {
        this.idJourney = this.$route.query.idJourney
        this.$store.dispatch('setNewJourney', this.singleJourneyDetail)
      }).then(() => this.getSingleStory())
    } else if (this.$route.query.idJourney) {
      this.getSingleJourney().then(() => {
        this.idJourney = this.$route.query.idJourney
        this.$store.dispatch('setNewJourney', this.singleJourneyDetail)
      })
    } else if (this.$route.query.idStory) {
      this.getSingleStory()
    } else {
      console.log("no parameter idStory o idJourney found in querystring")
    }

  },
  computed: {
    getPreferredLanguage: {
        get: function () {
            return this.$store.getters.getPreferredLanguage;
        }
    },

    disableSaveAsDraftJourney: {
      get: function () {
        return (this.cacheJourney.journeyTitle.length >= 4 && this.cacheJourney.journeyDescription.length >= 4);
      }
    },
    disablePublishJourney: {
      //to check
      get: function () {
        return (this.disableSaveAsDraftJourney);
      }
    },
    getUser: {
      get: function () {
        return this.$store.getters.getUser;
      }
    },
    cacheJourney: {
      get: function () {
        return this.$store.getters.getNewJourneys
      }
    }

  },
  methods: {
    async getSingleJourney() {
      try {


        this.$store.dispatch('setLoading', true)
        let completeurl = this.apiUrl + '/getJourney?id=' + this.$route.query.idJourney
        let tempSingleJourneyDetail
        tempSingleJourneyDetail = await this.getaxiosResponse(completeurl)
        if (typeof tempSingleJourneyDetail.content == "string") {
          tempSingleJourneyDetail.content = JSON.parse(tempSingleJourneyDetail.content)
        }
        this.singleJourneyDetail = tempSingleJourneyDetail.data
        this.$store.dispatch('setLoading', false)
        if (tempSingleJourneyDetail == null) {
          console.log('you do not have the correct credentials to view the story')
          this.$router.push({
            name: 'errorPage'
          })
        }
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: 'errorPage'
        })
      }
    },

    setJourneyTitle() {
      this.$store.dispatch('setJourneyTitle', this.cacheJourney.journeyTitle)
    },
    setJourneyDescription() {
      this.$store.dispatch('setJourneyDescription', this.cacheJourney.journeyDescription)
    },
    async getSingleStory() {
      try {

        this.$store.dispatch('setLoading', true)
        let completeurl = this.apiUrl + '/getSingleStory?id=' + this.$route.query.idStory
        let tempSingleStoryDetail
        tempSingleStoryDetail = await this.getaxiosResponse(completeurl)
        if (typeof tempSingleStoryDetail.content == "string") {
          tempSingleStoryDetail.content = JSON.parse(tempSingleStoryDetail.content)

        }

        this.$store.dispatch('setJourneyStoriesArrayObjectIdDescription', tempSingleStoryDetail.data)

        //this.cacheJourney.storiesArrayObjectIdDescription.push(tempSingleStoryDetail.data)

        this.$store.dispatch('setLoading', false)
        if (tempSingleStoryDetail == null) {
          console.log('you do not have the correct credentials to view the story')
          this.$router.push({
            name: 'errorPage'
          })
        }
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: 'errorPage'
        })
      }
    },
    // before exit from creating journey
    goToHome: function () {
      //this.$store.dispatch("clearNewStory")
      //this.$indexdb.mediaFiles.clear()
      //this.$store.dispatch("setDialogSaveBeforeExit", false)
      this.$router.push({
        name: 'home'
      })
    },
    ////////////////////////////////////////////////////// Create/edit Journey /////////////////////////////

//format object for backend
async formatMapStoriesID(){
        this.mapStoriesArrayObjectIdDescription=[]
//map storiesArrayObjectIdDescription before send to BE ()
        this.cacheJourney.storiesArrayObjectIdDescription.forEach(
          element=>this.mapStoriesArrayObjectIdDescription.push({'id':element.stageID,'storyID':element.id,'descriptionStoryJourney':element.descriptionStoryJourney}))

},
async publicNewJourney() {
      await this.formatMapStoriesID().then(()=>this.uploadJourney(true))
    },
async  saveAsDraftNewJourney() {
      await this.formatMapStoriesID().then(()=>this.uploadJourney(false))
    },
    async uploadJourney(isPublic) {
      try {
        let messagejourney

      if (isPublic){
          //success message when create a public journey
            messagejourney = this.$i18n.t('messageLoadingPublishJourney');
        }else{
          //success message when create a draft journey
          messagejourney = this.$i18n.t('messageLoadingSavedJourney');
        }
        this.$store.dispatch('setLoadingJourney', {status:true,text:"You have created a Journey!",'description':messagejourney})


        //postJourney for new Journey
        //putJourney is for edit Journey
        let url
        if (Number.isInteger(parseInt(this.idJourney, 10))) {
          url = this.apiUrl + "/putJourney"
        } else {
          url = this.apiUrl + "/postJourney"
        }
        //before write in the db i have to remove the propriety toggle
        let objectBody
        if (Number.isInteger(parseInt(this.idJourney, 10))) {
          //example of valid storiesArrayObjectIdDescription
          //[{storyId:651,descriptionStoryJourney:"myFirstDescription 651 milano"},{storyId:166,descriptionStoryJourney:"myFirstDescription Bica"}] 
          objectBody = {
            id: this.idJourney.toString(),
            user: parseInt(this.getUser.id, 10),
            isPublic: isPublic,
            isJourney: this.cacheJourney.isJourney,
            journeyTitle: this.cacheJourney.journeyTitle,
            journeyDescription: this.cacheJourney.journeyDescription,
            storiesArrayObjectIdDescription: this.mapStoriesArrayObjectIdDescription,
            backgroundColor: this.cacheJourney.backgroundColor,
            language:this.$store.getters.getPreferredLanguage

          }
        } else {

        objectBody = {

            user: parseInt(this.getUser.id, 10),
            isPublic: isPublic,
            isJourney: this.cacheJourney.isJourney,
            journeyTitle: this.cacheJourney.journeyTitle,
            journeyDescription: this.cacheJourney.journeyDescription,
            storiesArrayObjectIdDescription: this.mapStoriesArrayObjectIdDescription,
            backgroundColor: this.cacheJourney.journeyBackgroundColor,
            language:this.$store.getters.getPreferredLanguage

          }
        }


              //console.log(JSON.stringify(objectBody))
              //console.log('objectBody', objectBody,'url',url)

        await this.$axios.post(url, objectBody, {
          headers: {
            "x-access-token": `Bearer ${this.$store.getters.getAccessToken}`
          }
        })


        let message
        if (this.cacheJourney.isPublic) {
          message = this.$t('JourneyPublicSuccess')
        } else {
          message = this.$t('JourneyDraftSuccess')
        }
        //RESET cache Journey when upload is successful
        this.$store.dispatch('clearNewJourney')
        this.$store.dispatch("setSnackbar", {
          color: 'green',
          text: message,
          active: true
        })
      this.$store.dispatch("setIsJourneyOrSingleStory", 1)
      this.$store.dispatch('setIsCreatedOrviewJourneys',0)
      this.$store.dispatch('setIsAllOrNearmeJourneys',0)
      this.$store.dispatch('setIsSavedOrPublishedJourneys',isPublic)

        this.goToHome()
        //clear
      } catch (error) {
        console.log(error);
        this.$store.dispatch('setLoadingStory', {
          status: false,
          text: ''
        })
        setTimeout(this.$store.dispatch("setSnackbar", {
          color: 'red',
          text: "storyError",
          active: true
        }), 5000)
        this.goToHome()
      }
    },

  }
}
</script>
<style>
.v-text-field__details{
  display: none;
}
.btnPublishDraftJourney{
  border-radius: 999rem ;
  padding: 15%;
}

/*@import "~vue-wysiwyg-lite/dist/vueWysiwyg.css";


.theme--light.v-footer{
  background-color: white;
}
*/
</style>
